/* eslint-disable no-underscore-dangle */

// Base types for preference scopes
export type ScopeData = {
  [key: string]: unknown
};

export type Scopes = {
  [scopeName: string]: ScopeData
};

export type PreferenceValue = {
  limit?: number
  __scopes?: Scopes
  [key: string]: unknown
};

export type PreferenceScopeValue = {
  __scopes?: Scopes
  [preferenceId: string]: PreferenceValue | Scopes | undefined
};

export type ScopeDefaults = {
  [key: string]: unknown
  __scopes?: Scopes
};

export default class Preference {
  public id: string;

  protected value: PreferenceValue;

  private scopeName: string;

  protected scopeDefaults: ScopeDefaults;

  constructor(
    id: string,
    values: PreferenceScopeValue,
    scopeName: string,
    scopeDefaults: ScopeDefaults = { __scopes: {} },
  ) {
    this.id = id;
    this.value = (values[this.id] as PreferenceValue) || { __scopes: {} };
    this.scopeName = scopeName;
    this.scopeDefaults = scopeDefaults;
  }

  addIntoScope(name: string, value: unknown): void {
    if (this.value.__scopes === undefined) {
      this.value.__scopes = {};
    }
    if (this.value.__scopes[this.scopeName] === undefined) {
      this.value.__scopes[this.scopeName] = {};
    }

    this.value.__scopes[this.scopeName][name] = value;
  }

  getFromScope(name: string): unknown {
    let result: unknown;

    if (this.value.__scopes && this.value.__scopes[this.scopeName]) {
      result = this.value.__scopes[this.scopeName][name];
    }

    return result;
  }

  toRawObject(): PreferenceValue {
    return this.value;
  }
}
/* eslint-enable no-underscore-dangle */
